import { Grid, List, Typography } from "@material-ui/core";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import { Split } from "../../utils/Split";
import ProjectImg from "../../assets/img/project.jpg";
import ProjectImg2 from "../../assets/img/project2.jpg";
import Counter from "./Counter";
import CounterType from "./CounterType";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Call from "../../service/API";
import { useMountAPI } from "../../hooks/APICall";
import useCustomState from "../../hooks/State";
import { useHistory } from "react-router";
import { SetCounterCategories } from "../../store/actions";
import { useDispatch } from "react-redux";

const Details = (props) => {
  const projectId = props.data.match.params.pId;
  const userId = props.data.match.params.userId;
  const image = projectId % 2 === 0 ? ProjectImg : ProjectImg2;

  const counterCategories = useCustomState([]);
  const existCounterCategories = useCustomState({});
  const categoriesIsLoading = useCustomState(true);
  const countersIsLoading = useCustomState(true);
  const thisUserCounters = useCustomState([]);
  const user = useCustomState({});
  const project = useCustomState({});

  const dispatch = useDispatch();

  const categoryUtils = {
    page: 1,
    count: 1000,
    categoryName: "",
    categoryDate: "",
    categories: counterCategories,
    isLoading: categoriesIsLoading,
    dispatch: dispatch,
  };

  const countersUtils = {
    page: 1,
    count: 10,
    userId: userId,
    projectId: projectId,
    isLoading: countersIsLoading,
    counters: thisUserCounters,
  };

  useMountAPI(fetchCategories, categoryUtils);
  useMountAPI(fetchCounters, countersUtils);

  const history = useHistory();

  useEffect(() => {
    const categories = {};
    if (!categoriesIsLoading.value && !countersIsLoading.value) {
      if (thisUserCounters.value.length == 0) {
        history.push("/admin/project-dash/" + projectId);
      }
      let categoryName;
      thisUserCounters.value.map((counter) => {
        categoryName = counter.water_meter_tag_info.water_meter_tag_name;
        if (categories[categoryName]) {
          categories[categoryName] = categories[categoryName] + 1;
        } else {
          categories[categoryName] = 1;
        }
      });
      existCounterCategories.handleChange(categories);
      user.handleChange(thisUserCounters.value[0].water_meter_user_info);
      project.handleChange(thisUserCounters.value[0].water_meter_project_info);
    }
  }, [categoriesIsLoading.value, countersIsLoading.value]);

  if (!categoriesIsLoading.value && !countersIsLoading.value) {
    return (
      <div
        style={{
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "24px",
        }}
      >
        <Grid container>
          <Grid align="center" item sx={12} sm={12} md={12} lg={12}>
            <div
              style={{
                // maxWidth: "820px",
                marginTop: "48px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                paddingBottom: "24px",
              }}
            >
              <img
                src={image}
                style={{
                  width: "160px",
                  height: "160px",
                  borderRadius: "50%",
                  marginTop: "-70px",
                }}
                alt="project"
              />
              <Typography style={{ fontSize: "24px" }}>
                <span>کنتورهای </span>
                <span style={{ color: "#1976d2" }}>
                  {user.value.user_name + " " + user.value.user_lastname + " "}
                </span>
                <span>در </span>
                <span style={{ color: "#d32f2f" }}>
                  {convertNumbers(project.value.project_name)}
                </span>
              </Typography>
              <hr />

              <Grid
                container
                style={{ paddingRight: "16px", paddingLeft: "16px" }}
              >
                <Grid item sx={12} sm={12} md={12} lg={12}>
                  <Grid container>
                    {counterCategories.value.map((category, idx) => {
                      return (
                        <CounterType
                          existCategories={existCounterCategories.value}
                          data={category}
                          key={idx}
                          index={idx}
                          projectId={projectId}
                          userId={userId}
                        />
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return null;
  }
};

export default Details;

const processCategories = (categories) => {
  const results = [];
  categories.map((cat, idx) => {
    const data = {
      registeredAt: cat.water_meter_tag_create_date,
      files: cat.water_meter_tag_files,
      id: cat.water_meter_tag_id,
      name: cat.water_meter_tag_name,
      info: cat.water_meter_tag_other_information,
    };
    results.push(data);
  });
  return results;
};

const fetchCategories = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const categoryName = utils.categoryName;
  const categoryDate = utils.categoryDate;
  const categories = utils.categories;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;

  const data = {
    page: page,
    count: count,
    water_meter_tag_name: categoryName,
    water_meter_type_create_date: categoryDate,
  };

  Call("POST", "WaterMeterTags/admin/getAll", data)
    .then((response) => {
      // console.log("categories: ", response);
      if (response.data.code == 200) {
        categories.handleChange(response.data.data);
        dispatch(SetCounterCategories(processCategories(response.data.data)));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const fetchCounters = (utils) => {
  const page = 1;
  const count = 10;
  const userId = utils.userId;
  const projectId = utils.projectId;
  const isLoading = utils.isLoading;
  const counters = utils.counters;

  const data = {
    page: page,
    count: count,
    user_id: userId,
    project_id: projectId,
  };

  Call("POST", "watermeters/admin/getAll", data)
    .then((response) => {
      // console.log("this user counters: ", response);
      if (response.data.code == 200) {
        counters.handleChange(response.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
